import { store } from "src/redux/store";
import { Mixpanel } from "./Mixpanel";

type Props = {
  title: string;
  eventName?: string;
  properties?: Record<string, any>;
};

const MixpanelNavigation = ({ title, eventName = "Feature Clicks", properties }: Props) => {
  const { sub, email } = store.getState()?.credential?.userTokenDecode || {};
  const ORGANIZATION_ID = localStorage.getItem("company_id");

  const eventProperties: Record<string, any> = {
    $id: sub,
    $email: email,
    company_id: ORGANIZATION_ID,
    feature: title,
    ...properties,
  };

  if (title === "self_training") {
    const selfTrainingV2Enable = store.getState()?.organization?.org?.selfTrainingV2Enable;
    eventProperties.isV2SelfTraining = selfTrainingV2Enable;
  }

  Mixpanel.identify(email, false);
  Mixpanel.track(eventName, eventProperties);
};

export default MixpanelNavigation;
